/** Checkout can return to public reading pages, never arbitrary URLs or actions. */
export function checkoutReturnPath(value: unknown): string {
    if (typeof value !== "string" || value.length > 2048 || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020]/.test(value)) return "/browse";
    try {
        const url = new URL(value, "https://checkout.invalid");
        if (url.origin !== "https://checkout.invalid") return "/browse";
        if (url.pathname !== "/browse" && !/^\/story\/[a-zA-Z0-9_-]+(?:\/read(?:\/[a-zA-Z0-9_-]+)?)?\/?$/.test(url.pathname)) return "/browse";
        return `${url.pathname}${url.search}${url.hash}`;
    } catch { return "/browse"; }
}

export function coinStoreHref(returnTo: unknown): string {
    return `/pricing?redirect=${encodeURIComponent(checkoutReturnPath(returnTo))}`;
}
